<template>
<div>
<v-menu bottom="" offset-y="">
<template v-slot:activator="{ on }">
<v-icon :class="favorited ? 'c-primary' : ''" class="fs-18" v-on="on">{{ favorited ? 'favorite' : 'favorite_border' }}</v-icon>
</template>
<v-list v-if="!$store.getters.getFavoriteByProviderId(match_id)">
<v-list-item :key="list.id" @click="createFavorite(list.id)" v-for="list in $store.state.lists">
<v-list-item-title v-text="list.name">
</v-list-item-title></v-list-item><v-list-item @click="removeFavorite($store.getters.getFavoriteByProviderId(match_id).id)" v-if="$store.getters.getFavoriteByProviderId(match_id)">
<v-list-item-title>Remove favorite</v-list-item-title>
</v-list-item><v-list-item @click="newListDialogIsVisible=true" v-else="">
<v-list-item-title>+ Add to new list
</v-list-item-title>
</v-list-item></v-list></v-menu><v-dialog v-model="newListDialogIsVisible" width="300px">
<v-card class="pxy-4">
<v-card-text class="pb-0">
<v-text-field label="List name" outlined="" v-model="listName">
</v-text-field></v-card-text><v-card-actions>
<v-btn @click="newListDialogIsVisible = false" text="">Cancel</v-btn>
<v-spacer>
</v-spacer><v-btn :disabled="!listName" @click="createListAndFavorite" primary="" text="">Create
</v-btn>
</v-card-actions></v-card></v-dialog></div></template>

<script>
import Api from '../../services/bright_finder.js'

export default {
  computed: {
    favorited: function() {
      return this.$store.getters.getFavoriteByProviderId(this.match_id)
    }
  },

  data: function() {
    return {
      listName: '',
      newListDialogIsVisible: false,
    }
  },

  methods: {
    createFavorite: function(list_id) {
      var vm = this
      Api.bright_finder.favorite.create({ list_id: list_id, provider_id: this.match_id }, function(resp) {
        vm.$store.commit('addFavorite', resp.data)
      })
    },

    createListAndFavorite: function() {
      var vm = this
      Api.bright_finder.list.create({ name: this.listName }, function(resp) {
        vm.newListDialogIsVisible = false
        vm.$store.commit('addList', resp.data)
        vm.createFavorite(resp.data.id)
      })
    },

    removeFavorite: function(id) {
      var vm = this
      Api.bright_finder.favorite.destroy(id, function(resp) {
        vm.$store.commit('removeFavorite', resp.data)
      })
    },
  },

  props: ['match_id']
}
</script>
